const jobPostSec = document.querySelector('.job-post-sec');
const jobPostTitle = jobPostSec?.querySelector('.job-post-sec__title');

if (jobPostSec && jobPostTitle) {
  const checkTitleLines = () => {
    const lineHeight = parseFloat(getComputedStyle(jobPostTitle).lineHeight);
    const lines = Math.round(jobPostTitle.scrollHeight / lineHeight);
    jobPostSec.classList.toggle('title-long', lines > 4);
  };

  let resizeTicking = false;
  window.addEventListener('resize', () => {
    if (resizeTicking) return;
    resizeTicking = true;
    requestAnimationFrame(() => {
      checkTitleLines();
      resizeTicking = false;
    });
  });

  checkTitleLines();
}
